<template src="./component.html"></template>

<script>
import { utmPhone } from '@/functions/utmPhone';

export default {
  name: 'Header',
  data() {
    return {
      showMenu: false,
      openModule: false,
      openModuleMb: false,
      formattedNumber: utmPhone().formattedNumber,
      phone: utmPhone().phone,
      mbOpenLogin: false,
      activeMenuLink: '',
    }
  },
  methods: {
    onMenu: function () {
      this.mbOpenLogin = false;
      this.showMenu = !this.showMenu;
      this.addOverflow (this.showMenu);
    },
    onModule: function () {
      this.openModule = !this.openModule;
    },
    onModuleMb: function () {
      this.openModuleMb = !this.openModuleMb;
    },
    onOpenLogin: function () {
      this.openModuleMb = false;
      this.showMenu = false;
      this.mbOpenLogin = !this.mbOpenLogin;
      this.addOverflow (this.mbOpenLogin);
    },
    onCloseMenu () {
      this.showMenu = false;
    },
    addOverflow: function (val) {
      if (val) {
        document.body.classList.add('modal-overflow');
      } else {
        document.body.classList.remove('modal-overflow');
      }
    },
  },
}
</script>

<style src="./component.scss" scoped lang="scss"/>
